module.exports = __webpack_public_path__ + "static/img/320_TO8_2491.4ca1614.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/320_TO8_2491.jpg
// module id = +s2K
// module chunks = 0